import {QueryClientProvider} from '@tanstack/react-query';
import {lazy, Suspense, useState} from 'react';
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';

import {EditorContainer} from './apps/editor/editorContainer';
import {CodeEntryContainer} from './apps/vote/codeEntryContainer';
import {VoterContainer} from './apps/vote/voterContainer';
import {VotesContainer} from './apps/votes/votesContainer';
import {ErrorBoundary} from './shared/components/errorBoundary';
import {SignedIn} from './shared/components/signedIn';
import {createQueryClient} from './shared/queryClient';

const PresenterContainer = lazy(() =>
    import('./apps/present/presenterContainer').then((m) => ({default: m.PresenterContainer})),
);

export const App = () => {
    const [queryClient] = useState(() => createQueryClient());
    const location = useLocation();

    return (
        <QueryClientProvider client={queryClient}>
            <ErrorBoundary resetKey={location.pathname}>
                <Suspense fallback={null}>
                    <Routes>
                        <Route path="/" element={<CodeEntryContainer />} />
                        <Route path="/v/:code" element={<VoterContainer />} />
                        <Route
                            path="/admin"
                            element={
                                <SignedIn>
                                    <VotesContainer />
                                </SignedIn>
                            }
                        />
                        <Route
                            path="/admin/ballots/:id"
                            element={
                                <SignedIn>
                                    <EditorContainer />
                                </SignedIn>
                            }
                        />
                        <Route
                            path="/present/:id"
                            element={
                                <SignedIn bare>
                                    <PresenterContainer />
                                </SignedIn>
                            }
                        />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </Suspense>
            </ErrorBoundary>
        </QueryClientProvider>
    );
};
